import React from 'react';
import { LayoutDashboard } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface DashboardIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const DashboardIcon: React.FC<DashboardIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <LayoutDashboard size={size} color={color} />
        </IconWrapper>
    );
};
